

class GoogleMap{
    defaultOptions() {
        return {
            '$container': null,
            'zoom': 6,
            'center':{
                'lat': 46.52863469527167, 
                'lng': 2.43896484375 
            }
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        this.data = [];
        this.response = null;

        this.mapInitialized = false;

        this.initialize();
    }

    initialize(){
        var self = this;

        this.$container.html('');

        this.mapId = 'map'+window.uniqid();
        this.$map = $('<div/>')
        .attr('id',this.mapId)
        .addClass('map');


        this.$container.append(this.$map);

        window.FFSS.on('onGoogleMapApiLoaded',function(){
            self.initMap();
        });
    }

    initMap(){
        this.map = new google.maps.Map(document.getElementById(this.mapId), this.getGoogleMapOptions());
        this.mapInitialized = true;
        if(this.response){
            this.setData(this.response);
        }
    }

    getGoogleMapOptions(){
        return {
            'center': this.settings.center,
            'zoom': this.settings.zoom,
        };
    }

    setData(xhr){
        this.response = xhr;
        let data = xhr.data;
        if(this.mapInitialized){
            this.data = data;
            this.$map.css("width","100%");
            this.$map.css("height",this.$container.innerHeight());
            this.build();
        }else{
            this.showMapUnavailable();
        }
    }

    clearMarkers(){
        if(this.markerCluster){
            this.markerCluster.clearMarkers();
        }
        if(this.markers){
            for(var i in this.markers){
                var marker = this.markers[i];

                marker.setMap(null);
            }
        }

        this.markers = [];

        this.map.setZoom(this.settings.zoom);
        this.map.setCenter(new google.maps.LatLng(this.settings.center.lat,this.settings.center.lng));
    }

    showMapUnavailable(){
        this.$map.append(
            $('<div/>')
            .addClass('alert alert-warning p-4 text-center')
            .append(
                "Vue carte non disponible : veuillez accepter l'utilisation des cookies Google Maps ou utiliser la vue liste."
            )
        )
    }

    build(){
        this.clearMarkers();

        for(var i in this.data){
            let item = this.data[i];

            if(item.coordinates == null){
                console.warn("La formation "+item.title+" n'a pas de coordonn&eacute;es.");
            }else{

                let marker = this.buildMarker(item);

                this.markers.push(marker);
            }
        }


        this.buildMarkerCluster();
    }

    buildMarkerCluster(){

        if(!this.markerCluster){
            let options = {
                'imagePath': "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
                'gridSize': 30,
                'zoomOnClick': false,
                'maxZoom': 10,
            };
            this.markerCluster = new markerClusterer.MarkerClusterer({
                'map': this.map,
                'markers': this.markers
            });
        }else{
            this.markerCluster.clearMarkers();
            this.markerCluster.addMarkers(this.markers);
        }

    }

    buildMarker(item){
        var self = this;

        let position = item.coordinates;

        position.lng += (Math.random() / 25000);
        position.lat += (Math.random() / 25000);

        if(!this.infowindow){
            this.infowindow = new google.maps.InfoWindow();
        }

        let marker = new google.maps.Marker({
            'position': position,
            'map': this.map,
            'description': this.buildMarkerContent(item),
        });

        google.maps.event.addListener(marker, 'click', function() {
            self.infowindow.setOptions({
                'content': this.description
            });
            self.infowindow.open(self.map, marker);
        });
        

        return marker;
    }

    buildMarkerContent(item){
        let $html = $('<div/>');


        let period = item.periode;

        let url = '/formation/detail?id='+item.Id;

        let $btnShow = $('<a/>')
        .attr('href',url)
        .addClass('btn btn-text text-primary formation-btn')
        .append(
            "Voir plus de d&eacute;tails"
        )
        .append(
            $('<i/>')
            .addClass('icon icon-plus icon-circle bg-primary')
        )

        let subject = "["+item.title+"] "+item.diplome.TitreCourtDiplome;
        let urlContact = 'mailto:'+item.organisme.email+'?subject='+subject;
        let $btnContact = $('<a/>')
        .attr('href',urlContact)
        .addClass('btn btn-primary formation-contact-btn')
        .append("Contactez l'organisme");

        $html.append(
            $('<div/>')
            .addClass('formation-infowindow')
            .append(
                $('<div/>')
                .addClass('formation')
                .append(
                    $('<div/>')
                    .addClass('formation-diplome')
                    .append(
                        $('<label/>')
                        .addClass('formation-diplome-label')
                        .append("Diplome :")
                    )
                    .append(
                        $('<div/>')
                        .addClass('formation-club-value')
                        .attr('title',item.diplome.TitreDiplome)
                        .append(item.diplome.TitreCourtDiplome)
                    )
                )
                .append(
                    $('<hr/>')
                )
                .append(
                    $('<div/>')
                    .addClass('formation-club')
                    .append(
                        $('<label/>')
                        .addClass('formation-club-label')
                        .append("Club :")
                    )
                    .append(
                        $('<div/>')
                        .addClass('formation-club-value')
                        .append(item.organisme.label)
                    )
                )
                .append(
                    $('<hr/>')
                )
                .append(
                    $('<div/>')
                    .addClass('formation-period')
                    .append(
                        $('<label/>')
                        .addClass('formation-period-label')
                        .append("Date(s) :")
                    )
                    .append(
                        $('<div/>')
                        .addClass('formation-period-value')
                        .append(period)
                    )
                )
                .append(
                    $('<hr/>')
                )
                .append(
                    $('<div/>')
                    .addClass('d-flex justify-content-end')
                    //.append($btnContact)
                    .append($btnShow)
                )
            )
        )


        return $html.html();
    }

    onShow(){
        google.maps.event.trigger(this.map, 'resize');
    }

}

module.exports = GoogleMap;